const SUPPORT_WIDGET_BASE_URL =
  process.env.NODE_ENV === 'production' ? 'https://support.cjtglobal.com' : 'http://support.cjton-dev.business.xy';

export const CJT_SUPPORT_WIDGET_CONFIG = {
  scriptUrl: `${SUPPORT_WIDGET_BASE_URL}/widget/embed.js`,
  frameUrl: `${SUPPORT_WIDGET_BASE_URL}/widget/frame`,
  siteKey: 'ipunique-website',
  launcherElementId: 'support-launcher',
  language: 'zh-CN',
  position: 'bottom-right',
};



// WEBPACK FOOTER //
// ./src/config/cjtSupportWidget.js